import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SectionHeadline(props) {
  var _props$alwaysCenter = props.alwaysCenter,
    alwaysCenter = _props$alwaysCenter === void 0 ? false : _props$alwaysCenter,
    description = props.description,
    id = props.id,
    _props$inverted = props.inverted,
    inverted = _props$inverted === void 0 ? false : _props$inverted,
    overline = props.overline,
    title = props.title;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      m: alwaysCenter ? 'auto' : null
    },
    children: [overline && /*#__PURE__*/_jsx(Typography, {
      id: id,
      component: "h2",
      variant: "body2",
      sx: _extends({
        fontWeight: 'bold',
        color: 'primary.main',
        mb: 1
      }, alwaysCenter && {
        textAlign: 'center'
      }),
      children: overline
    }), typeof title === 'string' ? /*#__PURE__*/_jsx(Typography, {
      variant: "h2",
      sx: function sx(theme) {
        return _extends({
          maxWidth: 500
        }, inverted ? {
          color: '#fff'
        } : _extends({
          color: 'primaryDark.900'
        }, theme.applyDarkStyles({
          color: 'grey.100'
        })), alwaysCenter && {
          textAlign: 'center',
          maxWidth: '100%'
        });
      },
      children: title
    }) : (/*#__PURE__*/React.cloneElement(title, {
      style: _extends({
        maxWidth: 500
      }, alwaysCenter && {
        maxWidth: '100%',
        textAlign: 'center'
      }, inverted && {
        color: '#fff'
      })
    })), description && /*#__PURE__*/_jsx(Typography, {
      sx: function sx(theme) {
        return _extends({
          mt: 1,
          mb: 3,
          maxWidth: 500
        }, inverted ? {
          color: 'grey.400'
        } : _extends({
          color: 'grey.800'
        }, theme.applyDarkStyles({
          color: 'grey.500'
        })), alwaysCenter && {
          textAlign: 'center',
          mx: 'auto'
        });
      },
      children: description
    })]
  });
}